import { CoreIcon } from '../core-icon';
import upDownColorSVG from '../../assets/icons/up-down-color.svg';
import type { IconProps } from '../core-icon';

export const UpDownColorIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={upDownColorSVG} {...props} />;
};
